import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { QueryKeys } from './queryKeys';
import { getAcceptedObjectsData } from 'utils/api';
import { AcceptedObjectMessageType } from 'types/apiTypes';

// TODO: Add parameters for filtering/pagination
export const useAcceptedObjectsQuery = (
  messageType: AcceptedObjectMessageType,
  page: number,
  pageSize: number
) => {
  return useQuery({
    queryKey: [QueryKeys.acceptedObjectsData, messageType, page, pageSize],
    queryFn: async () => {
      const data = await getAcceptedObjectsData(messageType, page, pageSize);
      return data;
    },
    // refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
  });
};
